import { call, put } from "@redux-saga/core/effects";
import loader from "../loader";
import { BodyType, createRequestSaga } from "./request";
import { ApiCallback, ApiResponse, verfiyResponse } from "./types/saga";

export interface PostSagaGenericParams<Type> {
  type: string;
  payload: ApiCallback<Type>;
  body: object;
  url: string;
  id?: string;
}

export function* updateSaga<Type>({
  body,
  payload,
  url,
}: PostSagaGenericParams<Type>) {
  yield put(loader.actions.showLoader());
  try {
    const response: ApiResponse<Type> = yield call(createRequestSaga, {
      method: "PUT",
      url: url || "",
      body: body,
      bodyType: BodyType.formdata,
    });

    if (verfiyResponse(response)) {
      payload.onSuccess(response.Message, response.Result);
    } else payload.onError(response.Message);
  } catch (e) {
    console.log("ERROR putSaga", e);
  } finally {
    yield put(loader.actions.hideLoader());
  }
}
